export default __webpack_public_path__ + "static/media/6px.369caa08.svg";